<template>
  <div class="sub-popover__content" v-on-clickaway="emitClickAway">
    <template v-if="isActiveEvents">
      <div class="sub-popover__content__active__lessons__header">
        <h4>{{ activeEvents.length === 1 ? i18n[this.locale]['lesson'] : i18n[this.locale]['lessons'] }} {{ i18n[this.locale]['selected'] }} </h4>
      </div>
      <div class="sub-popover__container">
          <select class="do-select active-events__select" @change="setStatusOnActiveEvents($event.target.value)"
                  v-model="activeEventsStatus">
            <option disabled value="">{{ i18n[this.locale]['choose_status'] }}</option>
            <option value="1">{{ i18n[this.locale]['set_handled'] }}</option>
            <option value="0">{{ i18n[this.locale]['set_not_handled'] }}</option>
          </select>
        <div class="active-events__select">
          <d-select-subs-active-events
            :possibleSubs="possibleSubs"
            :activeEvents="activeEvents"
            :isLoading="isActiveEventsLoading"
            :placeholder="$t('vue2.sub_scheduler.choose_sub')"
            :addClass="['small-font']"
            @add="addSubToActiveEvents">
          </d-select-subs-active-events>
        </div>
        <button
          class="do-bttn do-bttn--danger"
          style="margin: 0.5rem; width: calc(100% - 1rem)"
          v-if="hasActiveEventsWithSubs"
          :disabled="isActiveEventsLoading || activeEvents.length < 1"
          @click="isConfirmRemoveSubs = true">
          <span class="icon-user-minus" style="margin-right: 6px"></span>
          {{ i18n[this.locale]['remove_substitutes'] }}
        </button>
        <ModalConfirmation
          v-if="isConfirmRemoveSubs"
          :isSubmitButtonLoading="isActiveEventsLoading"
          :appendToBody="true"
          @close="isConfirmRemoveSubs = false"
          @confirm="confirmRemoveSubs"
          :isShowConfirmDeleteMessage="false"
          :showClose="false">
          <h3 class="pad-1" slot="item">{{ i18n[this.locale]['remove_substitutes'] }}?</h3>
           <div class="pad-1" slot="custom_warning">
             <p class="marg-0-top">{{ i18n[this.locale]['confirm_remove_substitutes_text'] }}</p>
             <table class="do-table do-table--striped" style="font-size: 11px;">
               <thead>
                 <tr>
                   <th style="text-align: left;">Vikar</th>
                   <th style="text-align: left;">Vikar for</th>
                 </tr>
               </thead>
               <tbody>
                 <tr v-for="(row, idx) in subsRemovalList" :key="'rm-' + idx">
                   <td>{{ row.subName }}</td>
                   <td>{{ row.forName }}</td>
                 </tr>
               </tbody>
             </table>
           </div>
          <p slot="confirmText">{{ i18n[this.locale]['remove_substitutes'] }}</p>
        </ModalConfirmation>
          <ul class="active-events">
            <li v-for="activeEvent in activeEvents"
                :key="activeEvent.calendar_id + activeEvent.event_id"
                class="active-events__event"
                :class="{'active-events__event--handled': activeEvent.lesson && activeEvent.lesson.v_status && activeEvent.lesson.v_status === 1}">
              <div class="active-events__event__border-left"
                   :style="{'backgroundColor': activeEvent.lesson.color}"></div>
              <div>
                <p><b>{{ activeEvent.lesson.title }}</b>, <i>{{ activeEvent.lessonLTTime }}</i></p>
                <p><span class="icon-user2"></span>{{ activeEvent.user_to_substitute }}</p>
                <p v-if="activeEvent.selectedSubs && activeEvent.selectedSubs.length > 0">
                  <span class="icon-users3"></span>
                  {{ activeEvent.selectedSubs.map(u => u.name).join(', ') }}
                </p>
              </div>
              <div class="do-spinner" v-if="isActiveEventsLoading"></div>
            </li>
          </ul>
        </div>
    </template>
    <template v-else>
      <div class="sub-popover__content__header" :style="{'backgroundColor': lesson.color}">
        <h3 v-if="lesson.event_type === 'absence'">{{ getUser(lesson.calendar_id) }}</h3>
        <h4>{{ lesson.title }},
          <a v-for="klass in klassesOnLesson"
             :href="klass.url" class="link-white marg-5-right" target="blank">
            {{ klass.name }}
            <span class="icon-calendar5" aria-hidden="true"></span>
          </a>
        </h4>
        <div class="clock-and-delete">
          <p><span class="icon-clock"></span> {{ lesson.start | time }} - {{ lesson.end | time }}</p>
          <DDropdown v-if="lesson.event_type !== 'absence'" :closeFromProp="propToCloseDropdown">
            <ul slot="list">
              <li v-if="!lesson.away" @click.stop="setActiveSplitLesson(lesson)">
                <span class="icon-wrench"></span> {{ i18n[locale]['split_lesson'] }}
              </li>
              <li @click.stop="setActiveEditTimes(lesson)">
                <span class="icon-clock"></span> {{ i18n[locale]['edit_times'] }}
              </li>
              <li class="d-item-warning" @click.stop="onDeletedLesson(lesson)">
                <span class="icon-bin"></span> {{ $t('vue2.substitution.delete_lesson') }}
              </li>
              <li @click.stop="$emit('setTheOutOfSchoolLesson', lesson)">
                <span class="icon-home2 icon-home2-away"></span>
                {{ i18n[locale].out_of_school }}
              </li>
              <li @click.stop="$emit('setIsCancelLesson', lesson)">
                <span class="icon-notification22"></span>
                {{ !isCanceled ? i18n[locale].cancel_event : i18n[locale].uncancel_event }}
              </li>
            </ul>
          </DDropdown>
          <div class="d-show-event__header__do-warning__container">
            <div class="d-show-event__header__do-warning do-warning do-warning--canceled" v-if="isCanceled">
              <span class="icon-notification22"></span> {{ i18n[locale].canceled }}
            </div>
            <div class="d-show-event__header__do-warning do-warning" v-if="isAway">
              <span class="icon-home2 icon-home2-away" style="margin-right: 2px"></span>
              {{ i18n[locale].out_of_school }}
            </div>
          </div>
        </div>
      </div>
      <div class="sub-popover__container">
        <template v-if="lesson.event_type !== 'absence'">
          <ul class="sub-popover__content__body">
            <li>
              <label class="d-label">
                <span class="icon-users"></span>
                {{
                  $t('vue2.sub_scheduler.choose_sub')
                }}
              </label>
              <dSelectSub
                :addClass="['small-font']"
                style="font-size: 11px"
                :user="user"
                :eventId="lesson.id"
                :startTime="lesson.start"
                :endTime="lesson.end"
                :subs="substitutesOnLesson"
                :othersOnLesson="othersOnLesson"
                @addedSubFromTeachers="propStatus = 1"
                @add="addSubstitute"
                @remove="removeSubstitute">
              </dSelectSub>
            </li>
            <li>
              <label class="d-label">
                <span class="icon-user"></span>
                {{ $t('vue2.sub_scheduler_popover.substitute_for') }}
              </label>
              <p>{{ user.name }}</p>
            </li>
            <li v-if="othersOnLesson.length > 0">
              <label class="d-label">
                <span class="icon-users"></span>
                {{
                  $t('vue2.substitution.other_users')
                }}
              </label>
              <div>
            <span v-for="(other, idx)  in othersOnLesson"
                  v-if="idx < showAllOnLesson"
                  :content="other.v_isUserAbsentFromLesson"
                  v-tippy="{
                    arrow: true,
                    zIndex: 123123123123,
                    onShow: () => other.v_isUserAbsentFromLesson.length > 0
                  }"
                  :class="{'user--is-absent': other.v_isUserAbsentFromLesson.length > 0}"
                  :key="other.id"> {{ other.name }}<span v-if="idx < othersOnLesson.length - 1">,</span> </span>
                <p v-show="showAllOnLesson < othersOnLesson.length" class="text-blue pointer"
                   @click="showAllOnLesson = othersOnLesson.length">
                  {{ $t('vue2.substitution.see_all') }}
                </p>
                <p v-show="showAllOnLesson > 3" class="text-blue pointer" @click="showAllOnLesson = 3">
                  {{ $t('vue2.substitution.see_less') }}</p>
              </div>
            </li>
            <LessonOverlapInKlass :lesson="lesson"></LessonOverlapInKlass>
            <li>
              <label class="d-label">
                <span class="icon-checkmark-circle"></span>
                {{
                  $t('vue2.sub_scheduler.status')
                }}
              </label>
              <lessonsSubstitutionStatus
                dropdown-placement="bottom-start"
                :user="user"
                :statusProp="propStatus"
                :lesson="lesson"
                :othersOnLesson="othersOnLesson"
                :userCalendarId="user.user_calendar_id"
                :isSubStatusPendingActive="isSubStatusPendingActive">
              </lessonsSubstitutionStatus>
            </li>
            <li>
              <label class="d-label">
                <span class="icon-user"></span>
                {{ i18n[this.locale]['edit_teachers'] }}
              </label>
              <div class="icon__bg-circle" v-if="!isEditTeacher" @click="isEditTeacher = true">
                <span class="icon-wrench"></span>
              </div>
              <transition name="fadeInLeft">
                <div v-if="isEditTeacher">
                  <Loader bgColor="#fff" v-show="isUpdatingSubstitutes" :isExtraSmall="true"
                          style="margin: 2rem auto;"></Loader>
                  <DSelectCalendars
                    v-show="!isUpdatingSubstitutes"
                    itemType="user"
                    :isDeleteAllAnOption="false"
                    :showTags="true"
                    :event="lesson"
                    :eventId="lesson.id"
                    :preSelectedItems="usersOnLesson"
                    :itemsThatCantBeDeleted="userCalIdsSubstituted"
                    :itemsUnselectable="[]"
                    :showCreateButton="false"
                    :isLoadingProp="isUpdatingTeachers"
                    @update="setUsers($event)">
                  </DSelectCalendars>
                </div>
              </transition>
            </li>
          </ul>
        </template>
        <template v-else>
          <div class="pad-10" style="font-size: 12px">
            <AbsenceReason
              :user_calendar_id="user.user_calendar_id"
              :reason="lesson"
              :internalNote="lesson.teacher_notes"
              @showLog="showLog(lesson)"
              @close="emitClose">
            </AbsenceReason>
          </div>
        </template>
        <div class="sub-popover__content__note">
          <label class="d-label">
            <span class="icon-pencil"></span>
            <template v-if="lesson.event_type === 'absence'">{{ $t('vue2.substitution.absence_notes') }}</template>
            <template v-else>{{ $t('vue2.substitution.substitute_notes') }}</template>
          </label>
          <weip noteType="teacher_notes"
                :textInput="lesson.teacher_notes"
                :lesson="lesson"
                @close="updateTeacherNote">
          </weip>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import dSelectSub from '../../DSelect/DSelectSubs'
import DSelectSubsActiveEvents from '../../DSelect/DSelectSubsActiveEvents'
import lessonsSubstitutionStatus from './SchedulerItemPopoverStatus'
import AbsenceReason from '../SubsUserAbsenceReason'
import {mapGetters} from 'vuex'
import docendo from '../../../docendo'
import moment from 'moment'
import {mixin as clickaway} from 'vue-clickaway'
import weip from '../../common/AppEIPWYZIWYG'
import eventbus from '../../../eventbus'
import DSelectCalendars from '../../DSelect/DSelectCalendars'
import Loader from '../../common/Loader'
import DDropdown from '../../common/DDropdown.vue'
import LessonOverlapInKlass from '../LessonOverlapInKlass.vue'
import ModalConfirmation from '../../Modals/ModalConfirmation.vue'

const I18N = {
  da: {
    absent: 'Fraværende',
    user_not_found: 'Brugeren er fjernet fra skolen',
    edit_teachers: 'Redigér underviser(e)',
    delete_lesson: 'Slet lektion',
    split_lesson: 'Opdel lektion',
    edit_times: 'Rediger tider',
    out_of_school: 'Ude af huset',
    cancel_event: 'Aflys timen',
    uncancel_event: 'Fortryd aflysning',
    canceled: 'Aflyst',
    choose_status: 'Vælg status',
    set_handled: 'Sæt som håndteret',
    set_not_handled: 'Sæt som ikke håndteret',
    lesson: 'Lektion',
    lessons: 'Lektioner',
    selected: 'valgt',
    remove_substitutes: 'Fjern vikarer',
    confirm_remove_substitutes_text: 'Dette vil fjerne alle vikarer på de valgte lektioner.'
  },
  nb: {
    absent: 'Fraværende',
    user_not_found: 'Brukeren er fjernet fra skolen',
    edit_teachers: 'Rediger lærer(e)',
    delete_lesson: 'Slett time',
    split_lesson: 'Del opp timen',
    edit_times: 'Rediger tider',
    out_of_school: 'Utenfor skolen',
    canceled: 'Avlyst',
    cancel_event: 'Avlys timen',
    uncancel_event: 'Angre avlysning',
    choose_status: 'Velg status',
    set_handled: 'Sett som håndtert',
    set_not_handled: 'Sett som ikke håndtert',
    lesson: 'Time',
    lessons: 'Timer',
    selected: 'valgt',
    remove_substitutes: 'Fjern vikarer',
    confirm_remove_substitutes_text: 'Dette vil fjerne alle vikarer på de valgte timene.'
  },
  en: {
    absent: 'Absent',
    user_not_found: 'User is removed from school',
    edit_teachers: 'Edit teacher(s)',
    delete_lesson: 'Delete lesson',
    split_lesson: 'Split lesson in two',
    edit_times: 'Edit times',
    out_of_school: 'Out of school',
    canceled: 'Canceled',
    cancel_event: 'Cancel lesson',
    uncancel_event: 'Undo cancellation',
    choose_status: 'Choose status',
    set_handled: 'Mark as handled',
    set_not_handled: 'Mark as not handled',
    lesson: 'Lesson',
    lessons: 'Lessons',
    selected: 'selected',
    remove_substitutes: 'Remove substitutes',
    confirm_remove_substitutes_text: 'This will remove all substitutes on the selected lessons.'
  }
}

export default {
  components: {
    LessonOverlapInKlass,
    DDropdown, Loader, DSelectCalendars, dSelectSub, DSelectSubsActiveEvents, lessonsSubstitutionStatus, AbsenceReason, weip, ModalConfirmation
  },
  props: {
    activeEventId: {
      type: Object
    },
    user: {
      type: Object,
      default: () => {
      }
    },
    locale: {
      default: 'da'
    },
    activeEvents: {
      type: Array,
      default: () => []
    },
    possibleSubs: {
      type: Array,
      default: () => []
    }
  },
  mixins: [clickaway],
  data () {
    return {
      isUpdatingSubstitutes: false,
      isEditTeacher: false,
      isUpdatingTeachers: false,
      showAllOnLesson: 3,
      propStatus: 3,
      isActiveEIP: false,
      hasSubstituteNoteChanged: false,
      propToCloseDropdown: 0,
      activeEventsStatus: '',
      isConfirmRemoveSubs: false
    }
  },
  filters: {
    time (date) {
      return moment(date).format('LT')
    }
  },
  computed: {
    ...mapGetters([
      'allCalendarsInHash',
      'userSet',
      'allUsersInHash',
      'isSubStatusPendingActive'
    ]),
    i18n () {
      return I18N
    },
    isActiveEvents () {
      return this.activeEvents.length > 0
    },
    hasActiveEventsWithSubs () {
      return this.activeEvents.some(ev => {
        const hasSelected = ev.selectedSubs && ev.selectedSubs.length > 0
        const hasLessonSubs = ev.lesson && ev.lesson.calendar_events && ev.lesson.calendar_events.some(ce => ce.substitute === true)
        return hasSelected || hasLessonSubs
      })
    },
    subsRemovalList () {
      const pairs = []
      this.activeEvents.forEach(ev => {
        // Prefer selectedSubs if present, otherwise derive from lesson.calendar_events
        const selected = Array.isArray(ev.selectedSubs) && ev.selectedSubs.length > 0
          ? ev.selectedSubs
          : (ev.lesson && Array.isArray(ev.lesson.calendar_events)
            ? ev.lesson.calendar_events.filter(ce => ce.substitute === true)
            : [])
        selected.forEach(ce => {
          const subName = ce.name
          // Try to resolve 'for' name
          let forName = ev.user_to_substitute
          if ((!forName || forName === '') && ce.substitute_for_user_id) {
            const u = this.allUsersInHash[ce.substitute_for_user_id]
            if (u && u.name) forName = u.name
          }
          pairs.push({subName, forName: forName || ''})
        })
      })
      // Deduplicate identical pairs
      const seen = {}
      const out = []
      for (let i = 0; i < pairs.length; i++) {
        const key = pairs[i].subName + '->' + pairs[i].forName
        if (!seen[key]) {
          seen[key] = true
          out.push(pairs[i])
        }
      }
      return out
    },
    isActiveEventsLoading () {
      return this.$store.state.subs.isActiveEventsLoading
    },
    lesson () {
      return this.allEventsInAHash[this.activeEventId.obj.id]
    },
    isCanceled () {
      return this.lesson.canceled
    },
    isAway () {
      return this.lesson.away
    },
    allUsersAndEvents () {
      return this.$store.state.subs.allUsersAndEvents
    },
    allEventsInAHash () {
      return this.$store.state.subs.allEventsInAHash
    },
    calsOnLesson () {
      return this.lesson.calendar_events.map(event => {
        return this.allCalendarsInHash[event.calendar_id]
      })
    },
    klassesOnLesson () {
      return this.calsOnLesson.filter(cal => cal && cal.type === 'klass' || cal && cal.type === 'other')
    },
    usersOnLesson () {
      const userIds = []
      this.lesson.calendar_events.forEach(cal => {
        if (cal.calendar_type === 'user' && !cal.substitute && cal.calendar_type === 'user' && cal.calendar_id !== this.lesson.calendar_id) {
          userIds.push(cal.calendar_id)
        }
      })
      return userIds
    },
    userCalIdsSubstituted () {
      const userIdsSubstituted = this.lesson.calendar_events.map(cal => cal.substitute_for_user_id)
      return userIdsSubstituted.filter(userId => this.allUsersInHash[userId]).map(userId => this.allUsersInHash[userId].user_calendar_id)
    },
    othersOnLesson () {
      let users = []
      for (let i = 0; i < this.lesson.calendar_events.length; i++) {
        // Remove substitute and absentUser
        if (this.allUsersAndEvents[this.lesson.calendar_events[i].calendar_id] && !this.lesson.calendar_events[i].substitute && this.lesson.calendar_events[i].calendar_id !== this.user.user_calendar_id) {
          const user = this.allUsersAndEvents[this.lesson.calendar_events[i].calendar_id]
          user['v_isUserAbsentFromLesson'] = this.absenceOverlapLesson(this.lesson.id, user.dayAbsence)
          users.push(user)
        }
      }
      return users
    },
    userNotFoundPlaceholder () {
      return {
        id: 0,
        name: this.i18n[this.locale]['user_not_found'],
        type: 'user',
        url: '/calendar',
        calendar_id: 0,
        dayAbsence: [],
        dayEvents: [],
        dayAllEvents: [],
        default_thumb_url: '',
        user_tags: [],
        occupied: false,
        isOnLesson: false,
        currentEventId: 0,
        user_calendar_id: 0,
        isErrorUser: true
      }
    },
    substitutesOnLesson () {
      let subs = []
      this.lesson.calendar_events.map(event => {
        if (event.substitute && event.substitute_for_user_id === this.user.id) {
          let sub = this.allUsersAndEvents[event.calendar_id] ? this.allUsersAndEvents[event.calendar_id] : this.userNotFoundPlaceholder
          subs.push(sub)
        }
      })
      return subs
    }
  },
  methods: {
    addSubToActiveEvents (user) {
      this.$store.dispatch('addSubToActiveEvents', user.user_calendar_id)
    },
    setActiveSplitLesson (lesson) {
      this.propToCloseDropdown++
      this.$emit('splitLesson', lesson)
    },
    setActiveEditTimes (lesson) {
      this.propToCloseDropdown++
      this.$emit('editTimes', lesson)
    },
    onDeletedLesson (lesson) {
      this.propToCloseDropdown++
      this.$emit('deleteEvent', lesson)
    },
    setUsers (userCals) {
      this.isUpdatingTeachers = true
      const userCalIds = userCals.map(cal => cal.id)
      const calIdsNotInUserCalIds = this.lesson.calendar_events.filter(cal => !(cal.calendar_type === 'user' && cal.substitute === false && cal.calendar_id !== this.lesson.calendar_id)).map(cal => cal.calendar_id)
      const allCals = calIdsNotInUserCalIds.concat(userCalIds)
      const updates = [{event_id: this.lesson.id, calendar_ids: allCals}]
      docendo.updateEvents(this.lesson.school_id, updates, success => {
        this.$store.dispatch('getAllDayEvents')
        this.isUpdatingTeachers = false
      }, failure => {
        console.log('failure', failure)
      })
    },
    showLog (event) {
      this.$emit('showLog', event)
    },
    absenceOverlapLesson (lessonId, absenceIds) {
      let absenceOverlapping = []
      const absenceEvents = absenceIds.map(eventId => this.allEventsInAHash[eventId])
      const lessonEvent = this.allEventsInAHash[lessonId]
      absenceEvents.forEach(absenceEvent => {
        const range1 = moment.range(absenceEvent.start, absenceEvent.end)
        const range2 = moment.range(lessonEvent.start, lessonEvent.end)
        if (range1.intersect(range2)) {
          const absentLessonReadable = absenceEvent.title + ' ' + moment(absenceEvent.start).format('LT') + '-' + moment(absenceEvent.end).format('LT')
          absenceOverlapping.push(absentLessonReadable)
        }
      })
      return absenceOverlapping
    },
    getUser (calId) {
      return this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].name ? this.allCalendarsInHash[calId].name : 'Not found'
    },
    updateTeacherNote (obj) {
      // Don't update if teacher_note is the same
      if ((this.lesson.teacher_notes === obj.text) || !obj) {
        return
      }
      let eventIdAndTeacherNote = {
        eventId: this.lesson.id,
        note: obj.text
      }
      docendo.updateEvent(window.SCHOOL.id, obj.lesson.id, {[obj.noteType]: obj.text}, success => {
        this.$store.commit('updateTeacherNoteOnEvent', eventIdAndTeacherNote)
      })
    },
    addSubstitute (userObj) {
      if (userObj.isWithAvailability) {
        const updateObj = {
          eventToSub: this.lesson,
          userAsSub: userObj,
          userToSub: this.user
        }
        this.$emit('chooseSubType', updateObj)
        this.emitClose()
        return
      }
      this.isUpdatingSubstitutes = true
      if (this.isSubStatusPendingActive) {
        this.propStatus = 2
      }
      // this.propStatus = 1
      let userEventObj = {cal_id: userObj.user_calendar_id, event_id: this.lesson.id}
      docendo.eventAddSubstitute(this.lesson.id, userObj.id, this.user.id, data => {
        this.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data))
        this.$store.commit('addEventOnAllUsersWithEvents', userEventObj)
        this.isUpdatingSubstitutes = false
      })
    },
    setStatusOnActiveEvents (val) {
      console.log('Valgt status:', val)
      this.$store.dispatch('updateStatusOnActiveEvents', val)
      // gør dit her
    },
    confirmRemoveSubs () {
      this.$store.dispatch('removeSubsOnActiveEvents')
      this.isConfirmRemoveSubs = false
    },
    removeSubstitute (userObj) {
      this.isUpdatingSubstitutes = true
      // Check if any subs for the sub that needs to be removed
      let subsForTheSub = []
      this.lesson.calendar_events.forEach(calEvent => {
        if (calEvent.substitute && calEvent.substitute_for_user_id === userObj.id) {
          subsForTheSub.indexOf(calEvent.calendar_id) < 0 ? subsForTheSub.push(calEvent.calendar_id) : null
        }
      })
      let userAndSubsForUser = {
        user: this.user,
        lesson: this.lesson,
        subToBeRemoved: userObj,
        subsForTheSubToBeRemoved: subsForTheSub
      }
      if (subsForTheSub.length > 0) {
        this.$emit('removeSubs', userAndSubsForUser)
        return
      }
      // For legacy purpose
      this.propStatus = 0
      docendo.eventRemoveSubstitute(this.lesson.id, userObj.id, this.user.id, data => {
        this.$store.commit('updateEventOnAllEventsInAHash', JSON.parse(data))
        this.$store.commit('removeEventOnAllUsersWithEvents', {
          cal_id: userObj.user_calendar_id,
          event_id: this.lesson.id
        })
        this.isUpdatingSubstitutes = false
      })
    },
    emitClose (e) {
      this.$emit('close')
    },
    emitClickAway (evt) {
      if (this.isActiveEvents) {
        const target = evt.target
        const classesNotToTarget = ['day-cal__event__subs__img', 'day-cal__event__subs', 'select-user__button', 'day-cal__event__other', 'icon-user']
        if (target && classesNotToTarget.some(cls => target.classList.contains(cls))) {
          return
        }
      }
      const targ = evt.target.closest('ul')
      // Dont close if it is DSelect popper.js from bottom of DOM
      if ((targ && targ.classList.contains('d-select__items__container')) || eventbus.isLessonNoteChangedWithoutSaving) {
        return
      }
      this.$emit('clickaway')
    }
  }
}
</script>

<style scoped>
@import '../../../assets/css/variables.css';

.sub-popover__content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.sub-popover__content__header {
  padding: 10px;
  border-radius: 0;
}

.sub-popover__content__header p {
  font-size: 12px;
  color: #ffffff;
}

.sub-popover__content__header h3 {
  color: #ffffff;
}

.sub-popover__content__header h4 {
  margin-bottom: 5px;
  color: #ffffff;
  padding-right: 15px;
}

ul.sub-popover__content__body {
  font-size: 10px;
  margin: 0;
}

ul.sub-popover__content__body > li {
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #edf0f5;
}


.sub-popover__content__note {
  padding: 1rem;
  font-size: 10px;
}

.sub-popover__content__body h4 {
  margin-bottom: 10px;
}

.border-bottom {
  border-bottom: 1px solid #edf0f5;
}

.marg-5-right {
  margin-right: 5px;
}

.user--is-absent {
  color: #FA565AFF;
  text-decoration: line-through;
}

.user--is-absent:before {
  padding-right: 2px;
  content: "\ED4F";
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  -webkit-font-feature-settings: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.d-label {
  margin-bottom: 0.25rem;
}

.d-link {
  cursor: pointer;
  font-style: italic;
  color: var(--blue);
}

.clock-and-delete {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #fff;
  margin-right: -10px;
}

.clock-and-delete .d-show-event__header__do-warning__container {
  position: initial;
}

.sub-popover__container {
  flex-grow: 1; /* Take up the remaining available space */
  overflow-y: auto; /* Allow scrolling if content overflows */
  max-height: 100%; /* Prevent it from growing too large */
  overscroll-behavior: contain;
}

.do-warning.do-warning--canceled {
  background-color: #fddddd;
  color: #c20006;
  border-color: #fddddd;
}

.sub-popover__content__active__lessons__header {
  background: #fff;
  padding: 1rem;
  overflow: hidden;
  color: #3d4340;
  border-bottom: 1px solid #d8d8d8;
  position: relative;
}

.sub-popover__content__active__lessons__body {
  padding: 1rem;
}

.active-events__select {
  margin: 0.5rem;
  width: calc(100% - 1rem);
}

.active-events {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.5rem;
}

.active-events__event {
  border: 1px solid #eee;
  background: #fff;
  padding: 0.25rem 0.25rem 0.25rem 1rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 4px 4px 0;
  font-size: 12px;
  line-height: 18px;
}

.active-events__event.active-events__event--handled {
  background-color: #3ecf8e !important;
}

.active-events__event__border-left {
  width: 3px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// SchedulerItemPopover.vue?122bf235